import { render, staticRenderFns } from "./MrpDetailModal.vue?vue&type=template&id=cb00581e&scoped=true"
import script from "./MrpDetailModal.vue?vue&type=script&lang=js"
export * from "./MrpDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MrpDetailModal.vue?vue&type=style&index=0&id=cb00581e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb00581e",
  null
  
)

export default component.exports